module.exports = __webpack_public_path__ + "static/img/anB_2.f9b2830.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/anB_2.png
// module id = 1258
// module chunks = 1